export default "__VITE_ASSET__CEY2HoqK__"